<template>
    <router-view ref="routerView"></router-view>
</template>
<script>
import Account from "@/services/account.js";

export default {
    components: {},
    data() {
        return {
            business: null,
            businesses: []
        };
    },
    created() {
        this.$store.commit("setIsBusinessPage", true);
        this.$store.commit("setIsBusinessLoading", true);
        this.$store.commit("setIsBusinessNotFound", false);
    },
    beforeMount: async function () {
        try {
            const business = await Account.getBusinessByEncodedId(
                this.$route.params.encodedBusinessId
            );
            this.business = business.resource;
        } catch (error) {
            // this.redirectToSchedule();
            this.business = {};
            this.business["id"] = this.$route.params.encodedBusinessId;
        }

        const settings = await this._getSetting();
        await this.getBusinesses();

        const availBusinessIds = this.businesses.map(business => business.id);

        if (settings.business.id !== this.business.id) {
            if (availBusinessIds.includes(this.business.id)) {
                await this.switchBusiness(this.business.id);
            } else {
                document.location = process.env.APPS + "404/";
                return;
            }
        } else {
            this.$store.commit("setIsBusinessPage", false);
            this.$store.commit("setIsBusinessLoading", false);
        }
    },
    methods: {
        redirectToSchedule() {
            this.$router.push({
                name: "schedule"
            });
        },
        async getBusinesses() {
            let self = this;
            if (!self.businesses.length) {
                await this.$http
                    .get(process.env.ACTOR_SERVICE + "staff/businesses")
                    .then(response => {
                        self.businesses = response.data.response.resources;
                    });
            }
        },
        async switchBusiness(businessId) {
            document.body.style.cursor = "wait";
            const response = await $.getJSON(
                process.env.APPS + "index.php/ajax/business/checkAccess",
                { business_id: businessId }
            );
            if (response) {
                if (response.allowed) {
                    localStorage.removeItem("sf_username");
                    localStorage.removeItem("my_staff_url");
                    localStorage.setItem("Vetter-Token", response.token);
                    let res = await this.$http.get(
                        process.env.APPS +
                            "index.php/business/business/switch_instance?bid=" +
                            businessId +
                            "&redirect=0" // redirect = 0 tells the server to not use redirect (on the server side). let the client side handle the redirection
                    );
                    if (res?.data?.success) {
                        this.$socket.client.emit("v-broadcast-all", {
                            businessId: this.$root.setting.business_id,
                            userId: this.$root.currentActor.id,
                            action: "post-switch-instance",
                            url: window.location.href,
                            isAutomation: res?.data?.is_automation,
                            instance: localStorage.getItem("instance")
                        });
                    }
                } else {
                    // --- reset dialog
                    this.$root.$emit("bv::show::modal");
                    this.preventMessage = response.message;
                    this.$refs.preventSwitchModal.show();
                }
            }
            document.body.style.cursor = "";
            return response;
        }
    }
};
</script>
